import type { ReactNode } from "react";
import { Link } from "react-router";
import type { SiteInfo } from "@/components/UI/SitesMap/types";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { FEATURE_FLAGS } from "@/utils/feature-flag-constants";
import { CardLayout } from "@/views/TrialHomeScreen/components/CardLayout";

type Props = { siteInfo: SiteInfo | null; invKey?: string | null };

const ContactBlock = ({
  role,
  name,
  email,
  phone,
}: {
  role: string;
  name: ReactNode;
  email?: string;
  phone?: string;
}) => (
  <div className="flex flex-col gap-1 py-3 border-b border-[#f0f0f0] last:border-0">
    <span className="text-[11px] font-semibold uppercase tracking-wide text-[#8C8C8C]">
      {role}
    </span>
    <span className="text-[14px] font-medium text-[#2B4752]">
      {name || "-"}
    </span>
    {email && (
      <a
        href={`mailto:${email}`}
        className="text-[12px] text-[#06709B] hover:underline"
      >
        {email}
      </a>
    )}
    {phone && <span className="text-[12px] text-[#8C8C8C]">{phone}</span>}
  </div>
);

export default function ContactsTab({ siteInfo, invKey }: Props) {
  const s = siteInfo;
  const profileHidden = useFeatureFlag(
    FEATURE_FLAGS.INVESTIGATOR_PROFILE_LINKS_HIDDEN,
  );

  return (
    <div className="w-full flex flex-col gap-4">
      <span className="text-[13px] text-[#2B4752] font-semibold">Contacts</span>

      <div className="grid lg:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-4">
        <CardLayout
          title="Clinical Staff"
          subtitle="Investigators and coordinators"
        >
          <div className="px-4">
            <ContactBlock
              role="Principal Investigator"
              name={
                invKey && s?.investigator_name && !profileHidden ? (
                  <Link
                    to={`/portfolio/investigators/${invKey}`}
                    className="text-[14px] font-medium text-[#2B4752] hover:text-[#1A6FAD] hover:underline"
                  >
                    {s.investigator_name}
                  </Link>
                ) : (
                  (s?.investigator_name ?? "-")
                )
              }
              email={s?.investigator_email ?? undefined}
            />
          </div>
        </CardLayout>
      </div>
    </div>
  );
}
